var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10.1916C15.6122 6.93236 12.9455 5.30273 10 5.30273C7.05448 5.30273 4.38781 6.93236 2 10.1916C4.38781 13.4509 7.05448 15.0805 10 15.0805C12.9455 15.0805 15.6122 13.4509 18 10.1916ZM10.1674 7.08432L10.2342 7.08431C12.3334 7.15273 14.3078 8.14661 16.1932 10.1598L16.2222 10.1916L15.9833 10.443C14.0913 12.3808 12.109 13.3027 10.0004 13.3027C11.8486 13.3027 13.3468 11.9098 13.3468 10.1916C13.3468 8.52547 11.938 7.16523 10.1674 7.08432ZM9.8812 13.3008L10.0004 13.3027C9.96051 13.3027 9.92077 13.3021 9.8812 13.3008ZM9.8812 13.3008L9.76665 13.2989C7.6674 13.2305 5.69306 12.2366 3.80764 10.2235L3.77778 10.1916L4.0175 9.94027C5.90955 8.00249 7.89186 7.08051 10.0004 7.08051L9.8334 7.08432C8.06282 7.16523 6.65401 8.52547 6.65401 10.1916C6.65401 11.8727 8.08825 13.2424 9.8812 13.3008Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.076471b7.svg";
export { ForwardRef as ReactComponent };